import { useState } from 'react';
import { Link } from 'react-router-dom';
import { supplierApi } from '../../api/supplier';

export function SupplierOnboardingPage() {
  const [msg, setMsg] = useState('');

  async function register() {
    const sup = await supplierApi.createSupplier({
      legal_name: 'Global Components Ltd',
      category: 'manufacturer',
      country: 'IN',
      gstin: '27AABCU9603R1ZM',
    });
    await supplierApi.approveSupplier(sup.id);
    await supplierApi.activateSupplier(sup.id);
    setMsg(`Onboarded ${sup.supplier_code}`);
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/suppliers" className="text-sm text-slate-600 hover:underline">← Supplier hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Supplier onboarding</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <button type="button" onClick={() => void register()}
        className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Register & activate sample supplier</button>
    </div>
  );
}
